export const NAMESPACE = "PortalSessionParticipantsFlyOver";
export const EDIT_PARTICIPANT_FORM_ID = "EditSessionParticipantFormId";

export const TAB_IDS = {
  DETAILS: "details",
  TASKS: "tasks",
  SESSIONS: "sessions"
};

export const TASK_TAB_IDS = {
  ALL: "all",
  COMPLETE: "complete",
  INCOMPLETE: "incomplete",
  DUE: "due"
};

export const TABS = [
  {
    title: "Details",
    id: TAB_IDS.DETAILS
  },
  {
    title: "Tasks",
    id: TAB_IDS.TASKS
  }
  // {
  //   title: "Sessions",
  //   id: TAB_IDS.SESSIONS
  // }
];

export const MODULES_TINY_MCE =
  "table media link code lists image codesample eqneditor wordcount";

export const FORMATS_TINY_MCE =
  "bold italic underline | superscript subscript link eqneditor | bullist numlist outdent indent | image | removeformat | code | codesample";

export const FIELD_IDS = {
  PHOTO: "photo",
  FIRST_NAME: "first_name",
  LAST_NAME: "last_name",
  EMAIL: "email",
  SALUTATION: "salutation",
  HONORIFIC: "honorific",
  JOB_TITLE: "job_title",
  COMPANY_NAME: "company_name",
  BIOGRAPHY: "biography",
  WEBSITE: "website",
  LINKEDIN_URL: "linkedin_url",
  TWITTER_URL: "twitter_url"
};
